import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound } from "@tanstack/react-router"

import {
  getBusinessEntityOverviewStatsQueryOptions,
  getExtendedBusinessEntityQueryOptions,
} from "~/modules/business-entities/business-entities.queries"
import { BusinessEntityOverview } from "~/modules/business-entities/components/business-entity-overview"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/business-entities/$businessEntitySlug/overview",
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const [extendedBusinessEntity] = await Promise.all([
      context.queryClient.ensureQueryData(
        getExtendedBusinessEntityQueryOptions({
          businessEntitySlug: params.businessEntitySlug,
        }),
      ),
      context.queryClient.ensureQueryData(
        getBusinessEntityOverviewStatsQueryOptions({
          businessEntitySlug: params.businessEntitySlug,
        }),
      ),
    ])

    if (!extendedBusinessEntity) {
      throw notFound()
    }
  },
})

function RouteComponent() {
  const { businessEntitySlug } = Route.useParams()

  const { data: businessEntity } = useSuspenseQuery(
    getExtendedBusinessEntityQueryOptions({
      businessEntitySlug,
    }),
  )
  const { data: stats } = useSuspenseQuery(
    getBusinessEntityOverviewStatsQueryOptions({
      businessEntitySlug,
    }),
  )

  if (!businessEntity) {
    throw notFound()
  }

  return (
    <BusinessEntityOverview businessEntity={businessEntity} stats={stats} />
  )
}
